export function random(): number {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return array[0] / 0xffffffff;
}

export function randomInt(max: number): number {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return array[0] % max;
}

export function randomId(bytes = 16): string {
  const array = new Uint8Array(bytes);
  window.crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, '0')).join('');
}

// Determines if a code should run based on a given probability (between 0 and 1)
export function shouldRunCodeByProbability(probability: number): boolean {
  if (!probability || probability < 0 || probability > 100) {
    return false;
  }

  const normalizedProbability = probability / 100;

  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);

  const random = array[0] / (0xffffffff + 1);

  return random < normalizedProbability;
}
